var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
var Scale = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  ", "\n  ", "\n  cursor: pointer;\n"], ["\n  display: inline-block;\n  ", "\n  ", "\n  cursor: pointer;\n"])), function (_a) {
    var direction = _a.direction;
    return direction === "right" && "margin-right: 12px;";
}, function (_a) {
    var direction = _a.direction;
    return direction === "left" && "margin-left: 12px;";
});
export default Scale;
var templateObject_1;
